<template>
<div v-show="!noGuessData" :style="columnMargin" class="guess-like">
  <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
    <div v-if="0 && pageId != '90005' && ajaxList.length" class="guess-like-title">
      <img class="guess-like-title-img" src="/clientmodule/distVueCli/newHomeVue/img/guess-like-title.png" alt="">
    </div>
    <div class='all-list'>
      <div v-for="(childListItem,leftIndex) in [leftList,rightList]" :key="leftIndex" class='left-list'>
        <div @click="toProdDetail(prodItem)" v-for="(prodItem,prodKey) in childListItem" :key="prodKey" class="prod-one">
          <img :class="prodItem.adPositionType ? 'ad-position-img' : 'prod-img'" :src="prodItem.imgUrl" alt="" />
          <div v-if="!prodItem.adPositionType" class="prod-padding">
            <div class="prod-name-bar">
              <span v-if='0 && prodItem.activityTag && prodItem.activityTag.length > 0' :class="prodItem.activityTag && prodItem.activityTag.length > 0 && prodItem.activityTag[0] == '限时抢购' ? 'prod-flash-tag' : 'prod-bg-tag'">{{prodItem.activityTag[0]}}</span>
              <span class="prod-name" v-html="prodItem.name"></span>
            </div>
            <div v-if="0" class='prod-activity'>
              <span v-for="(attributeItem,attributeIndex) in prodItem.attributeTag" :key="attributeIndex" :class="[attributeItem == '爱心购' ? 'prod-activity-lovely' : 'prod-activity-one','margin-top-3']">{{attributeItem}}</span>
              <span v-if='0' class="prod-activity-lovely margin-top-3">爱心购</span>
              <span v-if='0' class="prod-activity-point margin-top-3">积分抵现</span>
              <span v-if='0' class="prod-activity-gold-bean margin-top-3">金豆抵现</span>
            </div>
            <div v-if="prodItem.productLabels && prodItem.productLabels.length" class="margin-top-3" v-html='tagListToHtml(prodItem.productLabels)'></div>
            <div class="prod-price-bar">
              <div class="prod-price-bar-left">
                <div class="margin-r-9">¥ <span class="prod-price">{{prodItem.estimatedPrice != 'init' && Number(prodItem.estimatedPrice) < Number(prodItem.prodPrice) ? prodItem.estimatedPrice : prodItem.prodPrice}}</span><span v-if="prodItem.estimatedTag" class="margin-l-3">{{prodItem.estimatedTag}}</span></div>
                <div v-if="Number(prodItem.originPrice) > Number(prodItem.prodPrice)" class="prod-old-price">¥{{prodItem.originPrice}}</div>
              </div>
              <div @click.stop="addShopCart(prodItem)" class='prod-cart'></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </van-list>
</div>
</template>

<script>
import { List } from 'vant';
import axios from 'axios';
export default { 
  name: 'GuessLike',
  data() {
    return {
      ajaxList: [],
      loading: false,
      finished: false,
      leftList: [],
      rightList: [],
      leftListHeight: 0,
      rightListHeight: 0,
      userId: '',
      token: '',
      pageNo: 0,
      adPushSum: 0,
      addShopCartLock:{},
      noGuessData: false,
      prodTrackIndex: 0,
      prodIdList: []
    }
  },
  props: {
    item: Object,
  },
  components: {
    [List.name]: List,
  },
  created() {
    // var ccbMain = JSON.parse(clientTools.getCookie('ccb-main', true));
    // ccbMain && ccbMain.userid && (this.userId = ccbMain.userid);
  },
  mounted() { 
    console.log(this.item)
    this.item.adPositionList.forEach(o => {
      console.log(o.adPositionIndex)
    });
  },
  watch: {

  },
  computed: {
    labelStyle: function(){
      return this.$store.state.home.labelStyle
    },
    pageId: function(){
      return this.$store.state.home.pageId
    },
    prodCategoryId: function(){
      return this.$store.state.home.prodCategoryId
    },
    columnMargin(){
      var obj = {}
      if(this.item.marginObj){
        obj={
          'margin-top': this.item.marginObj.top,
          'margin-bottom': this.item.marginObj.bottom
        }
      }
			return obj
    }
  },
  methods: {
    onLoad(){
      this.pageNo++; 
      this.getData()
    },
    getData(){
      var self = this
      var paramsObj = {
        'pageId': '90005',
        'pageNo': this.pageNo,
        'classify': this.prodCategoryId,
        'token': this.token
      }
      clientTools.getCookie('QrqmPreviewUser') && (paramsObj.userId = clientTools.getCookie('QrqmPreviewUser'));
      var params = new FormData();
      for(var key in paramsObj){
        params.append(key, paramsObj[key])
      }
      axios.post('/client/getRecommendProdList.jhtml', params).then(function (res) {
        if(res.data && res.data.status == '200' && res.data.prodList && res.data.prodList.length > 0){
          !self.token && res.data.token && (self.token = res.data.token);
          //去重
          var obj={};
          var setList = res.data.prodList.reduce((cur,next)=>{obj[next.prodId] ? "" : obj[next.prodId] = true && cur.push(next);return cur},[])
          var ajaxProdList = setList.filter(o=>self.prodIdList.indexOf(o.prodId) == -1)
          ajaxProdList.forEach(prod => {
            prod.estimatedPrice = 'init'
            prod.estimatedTag = ''
            prod.priceType && (prod.priceType == 'FlashSale' || prod.priceType == 'MerchantFlashSale') && (prod.estimatedTag = '秒杀价');
            prod.prodId && self.prodIdList.push(prod.prodId)
          });
          if(self.item.adPositionList && self.item.adPositionList.length>0){
            var tempList = JSON.parse(JSON.stringify(self.item.adPositionList))
            var recordList = []
            self.item.adPositionList.forEach(o=>{
              if(tempList.length > 0 && Number(tempList[0].adPositionIndex) < (self.ajaxList.length + ajaxProdList.length)){
                ajaxProdList.splice(Number(tempList[0].adPositionIndex)-self.ajaxList.length,0,tempList[0])
              }else{
                recordList.push(tempList[0])
              }
              tempList.shift(0)
            })
            self.item.adPositionList = JSON.parse(JSON.stringify(recordList))
          }

          // if(self.item.adPositionList && self.item.adPositionList.length>0){
          //   var minPositionIndex = self.ajaxList.length - 1 - self.adPushSum
          //   var maxPositionIndex = self.ajaxList.length + ajaxProdList.length - self.adPushSum
          //   var adList = self.item.adPositionList.filter(o=>o.adPositionIndex>minPositionIndex && o.adPositionIndex<maxPositionIndex)
          //   adList.forEach(o => {
          //     self.adPushSum ++
          //     console.log(o.adPositionIndex)
          //     ajaxProdList.splice(Number(o.adPositionIndex),0,o)
          //   });
          // }
          self.ajaxList = self.ajaxList.concat(ajaxProdList)
          self.formatList(ajaxProdList)
          self.getProductEstimatedPrice(ajaxProdList)
        }else{
          if(self.pageNo == 1){
            self.loading = false;
            self.finished = true;
            self.noGuessData = true
            return
          }
          // self.loading = false;
          // self.finished = true;
          self.prodIdList = []
          self.token = ''
          self.pageNo = 1
          self.getData()
        }
      })
    },
    getProductEstimatedPrice(prodList){
      if(!prodList || prodList.length == 0){
        return
      }
      var prodInfos = ''
      prodList.forEach(prod => {
        var priceType = 'null';
        prod && prod.priceType && (priceType = prod.priceType);
        prod && prod.prodId && (prodInfos += prod.prodId + '_' + prod.prodPrice + '_' + priceType + ',');
      });
      prodInfos && (prodInfos = prodInfos.slice(0,-1));
      var params = new FormData();
      params.append('prodInfos', prodInfos)
      axios.post('/client/ajaxProductEstimatedPrice.jhtml', params).then(function (res) {
        if(res.data && res.data.resultCode && res.data.resultCode == '0' && res.data.result && res.data.result.length){
          res.data.result.forEach(estimatedItem => {
            var index = prodList.findIndex(o=>o.prodId == estimatedItem.prodId)
            if(index > -1){
              var tempPrice = prodList[index].prodPrice
              if(estimatedItem.price != undefined){
                tempPrice = estimatedItem.price
              }
              if(estimatedItem.estimatedPrice != undefined && Number(estimatedItem.estimatedPrice) < Number(tempPrice)){
                tempPrice = estimatedItem.estimatedPrice
                prodList[index].estimatedTag = '预估价'
              }
              prodList[index].estimatedPrice = Number(tempPrice).toFixed(2)
            }
          });
          // prodList.forEach(prod => {
          //   var index = res.data.result.findIndex(o=>o.prodId == prod.prodId && o.estimatedPrice < Number(prod.prodPrice))
          //   if(index > -1){
          //     prod.estimatedPrice = res.data.result[index].estimatedPrice
          //     prod.estimatedTag = '预估价'
          //   }
          // });
        }
      })
    },
    formatList(prodList) {
      var t = this
      // 异步更新数据
      prodList.forEach((prodItem,prodIndex) => {
        var tempHtml = ''
        if(prodItem.adPositionType){
          tempHtml = `<div class="remove-prod-one" style="display: none"><img class=" remove-ad-position-img" src="`+ prodItem.imgUrl +`" alt="" /></div>`
        }else{tempHtml = `
          <div class="remove-prod-one" style="display: none">
            <div class="remove-prod-img"></div>
            <div class="remove-prod-padding">
              <div class="remove-prod-name-bar">`;
                tempHtml = tempHtml + '<span class="remove-prod-name remove-prod-name' + prodIndex + '"></span>';
              tempHtml = tempHtml + '</div>'
              prodItem.productLabels && prodItem.productLabels.length && (tempHtml = tempHtml + '<div class="remove-margin-top-3 remove-prod-label' + prodIndex + '"></div>');
               tempHtml = tempHtml + `<div class="remove-prod-price-bar">
                <div class="remove-prod-price-bar-left">
                  <div class="remove-margin-r-9">¥ <span class="remove-prod-price">` +prodItem.prodPrice+ `</span></div>`;
              (Number(prodItem.originPrice) > Number(prodItem.prodPrice)) && (tempHtml = tempHtml + `<div class="remove-prod-old-price">¥` +prodItem.originPrice+ `</div>`);
              tempHtml = tempHtml + `</div>
                <div class='remove-prod-cart'></div>
              </div>
            </div>
          </div>`;
        }
        $('.guess-like').append(tempHtml)
        if(prodItem.productLabels && prodItem.productLabels.length){
          var labelHtml = clientTools.prodTagListToDom(prodItem.productLabels,this.labelStyle)
          $('.remove-prod-label'+prodIndex).html(labelHtml)
        }
        $('.remove-prod-name'+prodIndex).html(prodItem.name)
        var prodOneHeight = ($('.remove-prod-one').height()*100).toFixed(0)/100
        prodItem.prodTrackIndex = t.prodTrackIndex
        t.prodTrackIndex++
        if(t.leftListHeight > t.rightListHeight){
          t.rightListHeight += prodOneHeight
          t.rightList.push(prodItem)
        }else{
          t.leftListHeight += prodOneHeight
          t.leftList.push(prodItem)
        }
        // console.log('----------------------------')
        // console.log('index',prodIndex)
        // console.log(prodOneHeight)
        // console.log('leftListHeight',t.leftListHeight)
        // console.log('rightListHeight',t.rightListHeight)
        // console.log('----------------------------')
        $('.remove-prod-one').remove()
      });
      console.log(t.leftListHeight)
      console.log(t.rightListHeight)


      // 加载状态结束
      this.loading = false;

      // 数据全部加载完成
      // if (this.leftList.length + this.rightList.length >= 20) {
      //   this.finished = true;
      // }
    },
    prodUrlAddTemplateId(url){
      if(!url){
        return ""
      }
      if(url.indexOf('templateId=') > -1){
        return url
      }
      var tempString = url.indexOf('?') == -1 ? '?' : '&';
      return url + tempString + 'templateId=index_qrqm'
    },
    toProdDetail(obj){
      var self = this
      // var url = '/client/cpd_' + obj.prodId + '.jhtml'
      // window.location.href = url
      var url = self.prodUrlAddTemplateId(obj.prodUrl)
      if(obj.adPositionType){
        url = self.prodUrlAddTemplateId(obj.adHrefUrl)
        this.$store.commit('doTrack',{
          href: url,
          columnDefineId: self.item.columnDefineId,
          ccId: obj.ccId,
          adId: obj.adId,
          adName: obj.adName,
          idType: 'adId'
        });
      }else{
        var relId4 = obj.properties && obj.properties.recommendReason && obj.properties.recommendReason.sceneId ? obj.properties.recommendReason.sceneId : '';
        var relId5 = obj.properties && obj.properties.recommendReason && obj.properties.recommendReason.algorithmType ? obj.properties.recommendReason.algorithmType : '';
        this.$store.commit('doTrack',{
          href: url,
          columnDefineId: self.item.columnDefineId,
          ccId: obj.ccId || '',
          adId: obj.prodId,
          adName: obj.name,
          idType: 'guessProdId',
          relId4: relId4,
          relId5: relId5,
          index: obj.prodTrackIndex+""
        });
      }
      window.location.href = url
    },
    addShopCart(obj){
      var self = this
      if(self.addShopCartLock[obj.prodId]){
        return
      }
      var fqzxStatus = obj.productLabels && obj.productLabels.length && obj.productLabels.findIndex(o=>o.key=='FQZX') > -1;
      if(obj.isSku && obj.isSku == '0' && !fqzxStatus){
        var params = {
          "addTime": new Date().getTime(),
          "shopCar.productId": obj.prodId,
          "shopCar.productName": obj.name,
          "shopCar.productAmt": 1,
          "shopCar.productImage": obj.imgUrl,
          "shopCar.productPrice": obj.prodPrice,
          "shopCar.productType": '0',
          "shopCar.channelType": '1',
          "shopCar.buyDelivery": '01',
          "shopCar.payMode": obj.paymentId + '_null',
          "shopCar.merchantId": obj.merchantId,
          "shopCar.productCategoryId": obj.properties.prodCatId
        }
        self.addShopCartLock[obj.prodId] = true
        axios.get('/shoppingcart/addShopCarJS.jhtml', { params: params }).then(function(res){
          self.addShopCartLock[obj.prodId] = false
          if (res.data.resultCode == "0") {
            self.$store.commit('setPublicToast',{
              show: true,
              type: 'addShopcart',
              text: '添加成功，在购物车等亲~'
            });
            clientTools.updateBottomNavShopcarSum()
            // self.$toast('添加购物车成功');
          } else {
            self.$toast(res.data.msg);
          }
        })
        return
      }

      var url = '/client/cpd_' + obj.prodId + '.jhtml'
      obj.prodUrl && (url = obj.prodUrl);
      window.location.href = self.prodUrlAddTemplateId(url)
      
    },
    tagListToHtml: function(tagList){
      return clientTools.prodTagListToDom(tagList,this.labelStyle)
    }
  }
}
</script>

<style scoped>
.guess-like{
  /* margin-top: 15px; */
  width: 345px;
  margin-left: 15px;
  font-size: 13px;
  color: #333
}
.all-list{
  display: flex;
  justify-content: space-between;
}
.left-list, .right-list{
  width: 168px;
}
.prod-one{
  width: 168px;
  margin-top: 10px;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
}
.prod-padding{
  padding: 0 10px 6px 9px;
}
.prod-img{
  width: 168px;
  height: 168px;
  object-fit: contain;
  display: block;
}
.ad-position-img{
  width: 168px;
  display: block;
}
.prod-name-bar{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  text-overflow: ellipsis;
  margin-top: 6px;
}
.prod-sales-tag{
  background: url(./assets/tag_sales_bg.png) no-repeat center;
  background-size: 100%;
  padding: 1px 15px 1px 4px;
  font-size: 10px;
  color: #fff;
  margin-right: 5px
}
.prod-flash-tag{
  background: url(./assets/tag_flash_bg.png) no-repeat center;
  background-size: 100%;
  padding: 1px 15px 1px 4px;
  font-size: 10px;
  color: #fff;
  margin-right: 5px
}
.prod-world-tag{
  background: url(./assets/tag_world_bg.png) no-repeat center;
  background-size: 100%;
  padding: 1px 5px 1px 5px;
  font-size: 10px;
  color: #fff;
  margin-right: 5px
}
.prod-bg-tag{
  background: linear-gradient(262deg, #FFA569 0%, #FE0000 100%);
  border-radius: 7px 0 7px 0;
  padding: 1px 5px 1px 5px;
  font-size: 10px;
  color: #fff;
  margin-right: 5px
}
.prod-activity{
  font-size: 10px;
  color: #F72D17;
  display: flex;
  flex-wrap: wrap;
  max-height: 39px;
  overflow: hidden;
}
.margin-top-3{
  margin-top: 3px
}
.prod-activity-lovely{
  padding: 0 3px 0 13px;
  border-radius: 2px;
  background: #FFF0EE url(/clientmodule/distVueCli/miniProgramVue/img/lovely_icon.png) no-repeat left 3px center;
  background-size: 9px;
  margin-right: 5px;
  height: 16px;
  line-height: 16px;
}
.prod-activity-one{
    padding: 0 2px;
    border-radius: 2px;
    margin-right: 5px;
    border: 1px solid #F72D17;
    color: #F72D17;
    height: 14px;
    line-height: 15px;
}
.prod-activity-gold-bean{
  padding: 2px 3px 2px 15px;
  border-radius: 2px;
  background: #FFF0EE url(./assets/gold_bean_icon.png) no-repeat left 3px center;
  background-size: 9px;
  margin-right: 5px;
  color: #F38C01
}
.prod-activity-point{
  padding: 2px 3px 2px 15px;
  border-radius: 2px;
  background: #FFF0EE url(./assets/point_icon.png) no-repeat left 3px center;
  background-size: 9px;
  margin-right: 5px;
  color: #F38C01
}
.prod-price-bar{
  margin-top: 12px;
  font-size: 10px;
  color: #F72D17;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.prod-price-bar-left{
  width: 125px;
  /* display: flex;
  flex-wrap: wrap;
  align-items: center; */
}
.prod-price{
  font-size: 15px
}
.prod-old-price{
  margin-top: 2px;
  color: #999;
  text-decoration: line-through;
}
.margin-r-9{
  margin-right: 9px
}
.margin-l-3{
  margin-left: 3px
}
.prod-cart{
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #FFF4F4 url(./assets/cart_icon.png) no-repeat center;
  background-size: 20px
}
.guess-like-title{
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.guess-like-title-img{
  width: 104px;
  display: block
}
</style>